(function () {
  'use strict';

  var config = window.PrimeProof24Theme || {};
  var routes = config.routes || {};
  var drawer = document.querySelector('[data-cart-drawer]');
  var drawerBody = drawer && drawer.querySelector('[data-cart-drawer-body]');
  var drawerFoot = drawer && drawer.querySelector('[data-cart-drawer-foot]');
  var lastCartTrigger = null;

  function formatMoney(cents) {
    return new Intl.NumberFormat(config.locale || document.documentElement.lang || 'de-DE', {
      style: 'currency',
      currency: config.currency || 'EUR'
    }).format((Number(cents) || 0) / 100);
  }

  function setCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (node) {
      node.textContent = String(count || 0);
    });
  }

  function makeElement(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function renderDrawerCart(cart) {
    setCartCount(cart.item_count);
    if (!drawerBody || !drawerFoot) return;
    drawerBody.replaceChildren();
    if (!cart.item_count) {
      drawerBody.appendChild(makeElement('p', 'cart-drawer__empty', config.strings && config.strings.empty ? config.strings.empty : 'Cart is empty.'));
      drawerFoot.hidden = true;
      return;
    }

    cart.items.forEach(function (item, index) {
      var line = makeElement('article', 'drawer-line');
      if (item.image) {
        var imageLink = makeElement('a');
        imageLink.href = item.url;
        var image = document.createElement('img');
        image.src = item.image;
        image.alt = item.product_title || '';
        image.width = 152;
        image.height = 152;
        imageLink.appendChild(image);
        line.appendChild(imageLink);
      } else {
        line.appendChild(makeElement('div', 'drawer-line__placeholder', '✓'));
      }

      var content = makeElement('div');
      var title = makeElement('h3');
      var link = makeElement('a', '', item.product_title);
      link.href = item.url;
      title.appendChild(link);
      content.appendChild(title);
      if (item.variant_title) content.appendChild(makeElement('p', '', item.variant_title));
      content.appendChild(makeElement('p', '', String(item.quantity) + ' × ' + formatMoney(item.final_price)));
      content.appendChild(makeElement('strong', '', formatMoney(item.final_line_price)));
      var remove = makeElement('button', 'text-link drawer-line__remove', config.strings && config.strings.remove ? config.strings.remove : 'Remove');
      remove.type = 'button';
      remove.dataset.cartRemove = item.key;
      remove.dataset.line = String(index + 1);
      content.appendChild(remove);
      line.appendChild(content);
      drawerBody.appendChild(line);
    });

    var subtotal = drawerFoot.querySelector('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    drawerFoot.hidden = false;
  }

  function getCart() {
    if (!routes.cartJson) return Promise.reject(new Error('Cart route is missing.'));
    return fetch(routes.cartJson, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart request failed.');
        return response.json();
      })
      .then(function (cart) {
        renderDrawerCart(cart);
        return cart;
      });
  }

  function openCart(trigger) {
    if (!drawer) {
      window.location.href = routes.cart || '/cart';
      return;
    }
    lastCartTrigger = trigger || null;
    drawer.hidden = false;
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    document.querySelectorAll('[data-cart-open]').forEach(function (button) { button.setAttribute('aria-expanded', 'true'); });
    getCart().catch(function () {});
    var close = drawer.querySelector('[data-cart-close]');
    if (close) close.focus();
  }

  function closeCart() {
    if (!drawer) return;
    drawer.hidden = true;
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
    document.querySelectorAll('[data-cart-open]').forEach(function (button) { button.setAttribute('aria-expanded', 'false'); });
    if (lastCartTrigger) lastCartTrigger.focus();
  }

  document.querySelectorAll('[data-cart-open]').forEach(function (button) {
    button.addEventListener('click', function () { openCart(button); });
  });
  if (drawer) {
    drawer.querySelectorAll('[data-cart-close]').forEach(function (button) { button.addEventListener('click', closeCart); });
    drawer.addEventListener('click', function (event) {
      var remove = event.target.closest('[data-cart-remove]');
      if (!remove || !routes.cartChange) return;
      remove.disabled = true;
      fetch(routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: remove.dataset.cartRemove, quantity: 0 })
      }).then(function (response) {
        if (!response.ok) throw new Error('Cart update failed.');
        return response.json();
      }).then(renderDrawerCart).catch(function () { remove.disabled = false; });
    });
  }

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var button = form.querySelector('[data-add-to-cart]');
    var status = form.querySelector('[data-product-form-status]');
    form.addEventListener('submit', function (event) {
      if (!routes.cartAdd || !drawer) return;
      event.preventDefault();
      if (button) button.disabled = true;
      if (status) status.textContent = '';
      fetch(routes.cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        body: new FormData(form)
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || 'Add to cart failed.');
          return data;
        });
      }).then(function () {
        if (status) status.textContent = config.strings && config.strings.added ? config.strings.added : 'Added to cart.';
        openCart(button);
      }).catch(function (error) {
        if (status) status.textContent = error.message || (config.strings && config.strings.error) || 'Could not add product.';
      }).finally(function () {
        if (button) {
          var select = form.querySelector('[data-variant-select]');
          button.disabled = select ? select.options[select.selectedIndex].dataset.available !== 'true' : false;
        }
      });
    });
  });

  document.querySelectorAll('[data-variant-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var form = select.closest('form');
      var section = select.closest('[data-product-section]');
      var option = select.options[select.selectedIndex];
      var available = option.dataset.available === 'true';
      var price = section && section.querySelector('[data-product-price]');
      var button = form && form.querySelector('[data-add-to-cart]');
      var label = form && form.querySelector('[data-add-label]');
      var dynamicButton = form && form.querySelector('.shopify-payment-button');
      if (price) price.textContent = option.dataset.price;
      if (button) button.disabled = !available;
      if (label) label.textContent = available ? label.dataset.availableLabel : label.dataset.soldOutLabel;
      if (dynamicButton) dynamicButton.hidden = !available;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', option.value);
      window.history.replaceState({}, '', url.toString());
    });
  });

  function syncTierNavigation(activeTier) {
    document.querySelectorAll('[data-tier-nav]').forEach(function (link) {
      var selected = link.dataset.tierNav === activeTier;
      link.classList.toggle('is-active', selected);
      if (selected) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
    document.querySelectorAll('[data-home-nav]').forEach(function (link) {
      var selected = activeTier === 'all';
      link.classList.toggle('is-active', selected);
      if (selected) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
  }

  document.querySelectorAll('[data-catalog-section]').forEach(function (section) {
    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-product-card]'));
    var buttons = section.querySelectorAll('[data-tier-filter]');
    var search = section.querySelector('[data-catalog-search]');
    var empty = section.querySelector('[data-catalog-no-results]');
    var requestedTier = new URLSearchParams(window.location.search).get('tier');
    var allowedTiers = ['diamond', 'gold', 'silver', 'new-test'];
    var tier = allowedTiers.indexOf(requestedTier) !== -1 ? requestedTier : 'all';
    syncTierNavigation(tier);
    function applyFilters() {
      var query = (search && search.value || '').toLocaleLowerCase();
      var visible = 0;
      cards.forEach(function (card) {
        var tierMatch = tier === 'all' || card.dataset.tier === tier;
        var textMatch = !query || (card.dataset.title || '').toLocaleLowerCase().indexOf(query) !== -1;
        card.hidden = !(tierMatch && textMatch);
        if (!card.hidden) visible += 1;
      });
      if (empty) empty.hidden = visible !== 0 || cards.length === 0;
    }
    buttons.forEach(function (button) {
      var selected = button.dataset.tierFilter === tier;
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      button.addEventListener('click', function () {
        tier = button.dataset.tierFilter;
        buttons.forEach(function (item) {
          var selected = item === button;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        var filterUrl = new URL(window.location.href);
        if (tier === 'all') filterUrl.searchParams.delete('tier');
        else filterUrl.searchParams.set('tier', tier);
        filterUrl.hash = 'ProductCatalog';
        window.history.replaceState({}, '', filterUrl.toString());
        syncTierNavigation(tier);
        applyFilters();
      });
    });
    if (search) search.addEventListener('input', applyFilters);
    applyFilters();
  });

  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () { select.form.submit(); });
  });

  document.querySelectorAll('[data-locale-select]').forEach(function (select) {
    select.addEventListener('change', function () { select.form.submit(); });
  });

  function syncInfoModalState() {
    var activeModal = window.location.hash && document.getElementById(window.location.hash.slice(1));
    var modalIsOpen = activeModal && activeModal.classList.contains('pp-info-modal') && !activeModal.classList.contains('is-closed');
    document.body.classList.toggle('no-scroll', Boolean(modalIsOpen));
    if (modalIsOpen) activeModal.focus({ preventScroll: true });
  }

  document.querySelectorAll('.pp-info-modal__close, .pp-info-modal__backdrop').forEach(function (control) {
    control.addEventListener('click', function (event) {
      event.preventDefault();
      var modal = control.closest('.pp-info-modal');
      if (modal) modal.classList.add('is-closed');
      document.body.classList.remove('no-scroll');
      if (window.history && window.history.replaceState) {
        window.history.replaceState(null, '', window.location.pathname + window.location.search);
      } else {
        window.location.hash = 'Footer';
      }
    });
  });

  window.addEventListener('hashchange', function () {
    document.querySelectorAll('.pp-info-modal.is-closed').forEach(function (modal) {
      modal.classList.remove('is-closed');
    });
    syncInfoModalState();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var activeModal = document.querySelector('.pp-info-modal:target');
    if (!activeModal || activeModal.classList.contains('is-closed')) return;
    var closeControl = activeModal.querySelector('.pp-info-modal__close');
    if (closeControl) closeControl.click();
  });

  syncInfoModalState();

  var mobileButton = document.querySelector('[data-mobile-menu-open]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (mobileButton && mobileNav) {
    mobileButton.addEventListener('click', function () {
      var open = mobileNav.hidden;
      mobileNav.hidden = !open;
      mobileButton.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var section = gallery.closest('[data-product-section]');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var counter = gallery.querySelector('[data-gallery-counter]');
    var lightbox = section && section.querySelector('[data-product-lightbox]');
    var launchers = Array.prototype.slice.call(gallery.querySelectorAll('[data-lightbox-launch]'));
    var index = 0;
    var pointerStart = null;

    function setSlide(next) {
      if (!slides.length) return;
      index = (Number(next) + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) { slide.hidden = slideIndex !== index; });
      thumbs.forEach(function (thumb, thumbIndex) {
        var selected = thumbIndex === index;
        thumb.classList.toggle('is-active', selected);
        thumb.setAttribute('aria-selected', selected ? 'true' : 'false');
      });
      if (counter) counter.textContent = String(index + 1) + ' / ' + String(slides.length);
    }

    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { setSlide(index - 1); });
    if (next) next.addEventListener('click', function () { setSlide(index + 1); });
    thumbs.forEach(function (thumb) { thumb.addEventListener('click', function () { setSlide(Number(thumb.dataset.index)); }); });
    gallery.addEventListener('pointerdown', function (event) {
      if (event.target.closest('button')) return;
      pointerStart = event.clientX;
    });
    gallery.addEventListener('pointerup', function (event) {
      if (pointerStart === null) return;
      var distance = event.clientX - pointerStart;
      pointerStart = null;
      if (Math.abs(distance) > 50) setSlide(index + (distance < 0 ? 1 : -1));
    });
    gallery.addEventListener('pointercancel', function () { pointerStart = null; });

    if (!lightbox || !launchers.length) return;
    var lightboxImage = lightbox.querySelector('[data-lightbox-image]');
    var lightboxMedia = lightbox.querySelector('[data-lightbox-media]');
    var lightboxStage = lightbox.querySelector('[data-lightbox-stage]');
    var lightboxCounter = lightbox.querySelector('[data-lightbox-counter]');
    var zoomValue = lightbox.querySelector('[data-zoom-value]');
    var zoomIn = lightbox.querySelector('[data-zoom-in]');
    var zoomOut = lightbox.querySelector('[data-zoom-out]');
    var zoomReset = lightbox.querySelector('[data-zoom-reset]');
    var lightboxIndex = 0;
    var scale = 1;
    var panX = 0;
    var panY = 0;
    var panStartX = 0;
    var panStartY = 0;
    var gestureX = 0;
    var gestureY = 0;
    var pinchDistance = 0;
    var pinchScale = 1;
    var pointers = new Map();
    var lastTrigger = null;
    var lastTap = 0;

    function applyTransform() {
      lightboxMedia.style.transform = 'translate3d(' + panX + 'px,' + panY + 'px,0) scale(' + scale + ')';
      zoomValue.textContent = String(Math.round(scale * 100)) + '%';
      zoomOut.disabled = scale <= 1;
      zoomIn.disabled = scale >= 4;
    }
    function setScale(value) {
      scale = Math.max(1, Math.min(4, Number(value) || 1));
      if (scale === 1) { panX = 0; panY = 0; }
      applyTransform();
    }
    function resetZoom() { scale = 1; panX = 0; panY = 0; applyTransform(); }
    function renderLightbox() {
      var item = launchers[lightboxIndex];
      lightboxImage.src = item.dataset.full;
      lightboxImage.alt = item.dataset.alt || '';
      lightboxCounter.textContent = String(lightboxIndex + 1) + ' / ' + String(launchers.length);
      lightbox.querySelector('[data-lightbox-prev]').hidden = launchers.length < 2;
      lightbox.querySelector('[data-lightbox-next]').hidden = launchers.length < 2;
      resetZoom();
    }
    function moveLightbox(direction) {
      lightboxIndex = (lightboxIndex + direction + launchers.length) % launchers.length;
      renderLightbox();
    }
    function openLightbox(trigger) {
      lastTrigger = trigger;
      var mediaIndex = trigger.dataset.index;
      lightboxIndex = Math.max(0, launchers.findIndex(function (item) { return item.dataset.index === mediaIndex; }));
      renderLightbox();
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.classList.add('no-scroll');
      lightbox.querySelector('[data-lightbox-close]').focus();
    }
    function closeLightbox() {
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      pointers.clear();
      resetZoom();
      document.body.classList.remove('no-scroll');
      if (lastTrigger) lastTrigger.focus();
    }
    function pointerDistance() {
      var values = Array.from(pointers.values());
      if (values.length < 2) return 0;
      return Math.hypot(values[0].x - values[1].x, values[0].y - values[1].y);
    }

    launchers.forEach(function (button) { button.addEventListener('click', function () { openLightbox(button); }); });
    lightbox.querySelectorAll('[data-lightbox-close]').forEach(function (button) { button.addEventListener('click', closeLightbox); });
    lightbox.querySelector('[data-lightbox-prev]').addEventListener('click', function () { moveLightbox(-1); });
    lightbox.querySelector('[data-lightbox-next]').addEventListener('click', function () { moveLightbox(1); });
    zoomIn.addEventListener('click', function () { setScale(scale + .5); });
    zoomOut.addEventListener('click', function () { setScale(scale - .5); });
    zoomReset.addEventListener('click', resetZoom);
    lightboxStage.addEventListener('dblclick', function (event) {
      if (event.target.closest('button')) return;
      setScale(scale > 1 ? 1 : 2.5);
    });
    lightboxStage.addEventListener('wheel', function (event) {
      event.preventDefault();
      setScale(scale + (event.deltaY < 0 ? .25 : -.25));
    }, { passive: false });
    lightboxStage.addEventListener('pointerdown', function (event) {
      if (event.target.closest('button')) return;
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (lightboxStage.setPointerCapture) {
        try { lightboxStage.setPointerCapture(event.pointerId); } catch (error) {}
      }
      if (pointers.size === 1) {
        gestureX = event.clientX;
        gestureY = event.clientY;
        panStartX = panX;
        panStartY = panY;
      } else if (pointers.size === 2) {
        pinchDistance = pointerDistance();
        pinchScale = scale;
      }
    });
    lightboxStage.addEventListener('pointermove', function (event) {
      if (!pointers.has(event.pointerId)) return;
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (pointers.size >= 2) {
        var distance = pointerDistance();
        if (pinchDistance) setScale(pinchScale * distance / pinchDistance);
        return;
      }
      if (scale > 1) {
        panX = panStartX + event.clientX - gestureX;
        panY = panStartY + event.clientY - gestureY;
        applyTransform();
      }
    });
    lightboxStage.addEventListener('pointerup', function (event) {
      var wasSingle = pointers.size === 1;
      var deltaX = event.clientX - gestureX;
      var deltaY = event.clientY - gestureY;
      pointers.delete(event.pointerId);
      if (wasSingle && scale === 1 && Math.abs(deltaX) > 55 && Math.abs(deltaX) > Math.abs(deltaY)) {
        moveLightbox(deltaX < 0 ? 1 : -1);
      } else if (wasSingle && Math.abs(deltaX) < 8 && Math.abs(deltaY) < 8 && event.pointerType === 'touch') {
        var now = Date.now();
        if (now - lastTap < 320) { setScale(scale > 1 ? 1 : 2.5); lastTap = 0; } else lastTap = now;
      }
      if (pointers.size === 1) {
        var remaining = Array.from(pointers.values())[0];
        gestureX = remaining.x;
        gestureY = remaining.y;
        panStartX = panX;
        panStartY = panY;
      }
    });
    lightboxStage.addEventListener('pointercancel', function (event) { pointers.delete(event.pointerId); });
    lightbox.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') { event.preventDefault(); closeLightbox(); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); moveLightbox(-1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); moveLightbox(1); }
      if (event.key === '+' || event.key === '=') { event.preventDefault(); setScale(scale + .5); }
      if (event.key === '-') { event.preventDefault(); setScale(scale - .5); }
      if (event.key === '0') { event.preventDefault(); resetZoom(); }
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (drawer && !drawer.hidden) closeCart();
    if (mobileNav && !mobileNav.hidden) {
      mobileNav.hidden = true;
      mobileButton.setAttribute('aria-expanded', 'false');
      mobileButton.focus();
    }
  });
})();
